import {MCountry} from "../../../../../server/routes/country/types";
import CountrySelectField from "../../../components/CountrySelectField";
import React from "react";
import {CountryFieldFC} from "./types";

const CountryField: CountryFieldFC = ({country, changeCountry}) => {
    const handlerChange = (countryId: MCountry['id'] | null) => {
        changeCountry(countryId ?? undefined);
    };

    return (
            <CountrySelectField
                value={country}
                AutocompleteProps={{
                    fullWidth: true,
                    placeholder: "Выберите страну",
                    size: "small",
                }}
                onChange={handlerChange}
            />
    );
};

export default CountryField;
